<div class="chip {{clickable? 'cursor-pointer': ''}}" [ngClass]="selected ? scheme.selected : scheme[colorscheme]">
    <ng-content></ng-content>
</div>
